import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        position: ''
    },
    mutations: {
        SET_POSITION: (state, oPosition) => {
            state.position = oPosition
        }
    },
    actions: {
        setPosition({
            commit
        }, oPosition) {
            commit('SET_POSITION', oPosition)
        }
    }
})